export default __webpack_public_path__ + "static/media/34.aa6699ca.JPG";